import {SODeletePlan} from '../../core/plan/so-delete-plan';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeletePlan extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeletePlan;
}